var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTravelAssistance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2040_5297)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.3227 28.1386C33.0052 25.4597 31.6908 23.0821 29.7615 21.3883V28.1386H33.3227Z",
    fill: "#FF8E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5057 21.4071C17.5791 22.7703 18.7111 23.857 20.0924 23.857C21.4737 23.857 22.6057 22.7703 22.679 21.4071C21.8632 21.6691 20.9941 21.811 20.0924 21.811C19.1906 21.811 18.3216 21.6691 17.5057 21.4071Z",
    fill: "#FF8E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4222 21.3883C8.49296 23.0821 7.17855 25.4596 6.86102 28.1386H10.4222V21.3883Z",
    fill: "#FF8E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5327 28.1374C17.8066 28.1374 19.04 28.4878 20.1091 29.1318C21.1783 28.4877 22.4115 28.1374 23.6855 28.1374H27.466V19.8462C27.0329 19.6309 26.5833 19.4438 26.1194 19.2881C25.7687 19.6429 25.3871 19.9672 24.9788 20.2561V21.2649C24.9788 23.9593 22.7867 26.1515 20.0922 26.1515C17.3978 26.1515 15.2057 23.9593 15.2057 21.2649V20.2561C14.7974 19.9671 14.4158 19.6429 14.0651 19.2881C13.6011 19.4438 13.1516 19.6309 12.7184 19.8462V28.1374H16.5327Z",
    fill: "#FF8E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.613 13.039C11.613 10.3905 13.7677 8.23569 16.4162 8.23569H23.7679C26.4164 8.23569 28.5711 10.3904 28.5711 13.039C28.5711 13.039 28.5573 13.8844 28.5312 14.155L33.2786 12.729V11.1354C33.2786 9.79423 32.8153 8.48035 31.974 7.43571C31.1328 6.39122 29.9478 5.65852 28.6375 5.37275L27.3431 5.09043C26.9246 4.99921 26.5808 4.70678 26.4236 4.30829C25.9201 3.03291 25.0548 1.95099 23.921 1.17964C22.7873 0.408289 21.4632 0.000610352 20.092 0.000610352C18.7208 0.000610352 17.3968 0.408289 16.2631 1.17956C15.1293 1.95092 14.2639 3.03283 13.7605 4.30821C13.6032 4.70671 13.2595 4.99905 12.8409 5.09035L11.5466 5.37268C10.2362 5.65844 9.05128 6.39115 8.21006 7.43564C7.36883 8.4802 6.90552 9.79408 6.90552 11.1353V12.729L11.6529 14.1549C11.6268 13.8843 11.613 13.039 11.613 13.039ZM18.8782 3.45842H21.306V5.75433H18.8782V3.45842Z",
    fill: "#FF8E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0936 19.5931C23.5507 19.5931 26.3532 16.7906 26.3532 13.3334V13.0396C26.3532 11.6126 25.1964 10.4558 23.7694 10.4558H16.4178C14.9908 10.4558 13.834 11.6126 13.834 13.0396V13.3334C13.8339 16.7906 16.6365 19.5931 20.0936 19.5931Z",
    fill: "#FF8E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6857 30.3589C22.4494 30.3589 21.3239 30.8374 20.4811 31.6175C20.3504 31.7386 20.2258 31.8663 20.1093 32.0013C19.9928 31.8663 19.8682 31.7386 19.7374 31.6175C18.8947 30.8374 17.7691 30.3589 16.5328 30.3589H0.50061V32.4791H16.8407C18.0501 32.4791 19.0305 33.4596 19.0305 34.669H21.1055C21.1055 33.4596 22.0859 32.4791 23.2953 32.4791H39.6843V30.3589H23.6857Z",
    fill: "#CC4700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3248 36.888H16.8111V34.6981H0.50061V36.994H14.5152V39.1839H25.6207V36.994H39.6843V34.6981H23.3248V36.888Z",
    fill: "#CC4700"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2040_5297"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.1837,
    height: 39.1837,
    fill: "white",
    transform: "translate(0.50061 0.000610352)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravelAssistance);
export default __webpack_public_path__ + "static/media/travelAssistance.b2a7c5e83e4d2f7fb5302ac40ad63a13.svg";
export { ForwardRef as ReactComponent };